import { useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { Section } from '../Section';
import { CheckmarkBulletPoint } from '../CheckmarkBulletPoint';
import { PriceCard } from '../PriceCard';
import { IPricingMethod } from '../../types/redux/promoInfo';
import { IPriceData } from '../../types/priceData';

import * as styles from './styles.css';

export const PricingSection: React.FC<{
  pricingMethods: IPricingMethod[];
  priceData: IPriceData;
  priceListUrl: string;
  onCreateDealButtonClick(): void;
}> = props => {
  const deviceType = useDeviceType();

  return (
    <Section className={cn(styles['section'], styles[deviceType])} testId="pricingSection">
      <div className={cn(styles['container'], styles[deviceType])}>
        <div>
          <h2 className={cn(styles['h2'], styles[deviceType])}>Сколько стоит Циан.Сделка</h2>
          <ul className={styles['bullet-points']}>
            <CheckmarkBulletPoint checkmarkColor="white_100">Электронная регистрация</CheckmarkBulletPoint>
            <CheckmarkBulletPoint checkmarkColor="white_100">
              Электронные подписи для всех участников сделки
            </CheckmarkBulletPoint>
            <CheckmarkBulletPoint checkmarkColor="white_100">
              Сопровождение персонального помощника на всех этапах
            </CheckmarkBulletPoint>
            <CheckmarkBulletPoint checkmarkColor="white_100">
              Удостоверение банком участников сделки
            </CheckmarkBulletPoint>
          </ul>
        </div>
        <PriceCard
          priceData={props.priceData}
          priceListUrl={props.priceListUrl}
          onCreateDealButtonClick={props.onCreateDealButtonClick}
        />
      </div>
    </Section>
  );
};
